import { AgentDesktopRouteParams } from '@agent/agent-interface/agent-desktop-routing.module';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { BookingStatus } from '@contact/upgrade';

import { AgentBookingChatInprocessConferenceComponent } from './inprocess-conference/agent-booking-chat-inprocess-conference.component';
import { AgentBookingChatInprocessForwardComponent } from './inprocess-forward/agent-booking-chat-inprocess-forward.component';
import { AgentBookingChatInprocessScriptRedirectionComponent } from './inprocess-script-redirection/agent-booking-chat-inprocess-script-redirection.component';
import { AgentBookingChatInprocessComponent } from './inprocess/agent-booking-chat-inprocess.component';
import { AgentBookingChatQualificationComponent } from './qualification/agent-booking-chat-qualification.component';

export enum AgentBookingChatInprocessState {
  conversation = 'conversation',
  forward = 'forward',
  conference = 'conference',
  scriptRedirection = 'script-redirection',
}

const routes: Routes = [
  {
    path: BookingStatus.IN_PROCESS.toLowerCase(),
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: AgentBookingChatInprocessState.conversation,
      },
      {
        path: AgentBookingChatInprocessState.conversation,
        component: AgentBookingChatInprocessComponent,
      },
      {
        path: `${AgentBookingChatInprocessState.forward}/:${AgentDesktopRouteParams.IsConf.key}`,
        component: AgentBookingChatInprocessForwardComponent,
      },
      {
        path: `${AgentBookingChatInprocessState.conference}/:${AgentDesktopRouteParams.IsConf.key}`,
        component: AgentBookingChatInprocessConferenceComponent,
      },
      {
        path: AgentBookingChatInprocessState.scriptRedirection,
        component: AgentBookingChatInprocessScriptRedirectionComponent,
      },
      {
        path: '**',
        redirectTo: '',
      },
    ],
  },
  {
    path: BookingStatus.POST_PROCESSING.toLowerCase(),
    component: AgentBookingChatQualificationComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AgentBookingChatRoutingModule {}
